import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './ui/styles.css';

const el = document.getElementById('root');
if (!el) throw new Error('no #root');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
